var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "content-padding" }, [
    _vm.referralCode
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-sm-6 offset-sm-3" }, [
            _c("img", {
              staticClass: "img-fluid rounded",
              attrs: {
                src: "https://beneat.co/images/invite-friends.png",
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "pt-4" }, [
              _c("h2", { staticClass: "mb-2" }, [
                _vm._v(_vm._s(_vm.$t("message.invite_friends.header_title")))
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("message.invite_friends.header_detail")) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _vm.creditStats
              ? _c("div", { staticClass: "card mt-4" }, [
                  _c("div", { staticClass: "card-body shadow-sm" }, [
                    _c(
                      "div",
                      { staticClass: "row no-gutters text-remark text-dark" },
                      [
                        _c("div", { staticClass: "col-12" }, [
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.invite_friends.your_stats")
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-8 text-info" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("message.invite_friends.total_friends")
                              ) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4 text-right" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.creditStats.total_friends))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-8 text-info" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("message.invite_friends.booked_friends")
                              ) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4 text-right" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.creditStats.booked_friends))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-8 text-info" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("message.invite_friends.acquired_coins")
                              ) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4 text-right" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm._f("currency")(
                                  _vm.creditStats.acquired_credits
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-8 text-secondary" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("message.invite_friends.remaining_coins")
                              ) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4 text-right" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm._f("currency")(
                                  _vm.creditStats.total_credits -
                                    _vm.creditStats.acquired_credits
                                )
                              )
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "pt-4" }, [
              _c("h3", [
                _vm._v(
                  _vm._s(_vm.$t("message.invite_friends.header_share_link"))
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group flex-fill" }, [
                _c("input", {
                  ref: "referralCode",
                  staticClass: "form-control flex-fill",
                  attrs: { type: "text" },
                  domProps: {
                    value:
                      "beneat.co/chat-booking?c=" +
                      _vm.referralCode.referral_code
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group-append" }, [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:copy",
                          value: _vm.referralCode.url_referral_code,
                          expression: "referralCode.url_referral_code",
                          arg: "copy"
                        }
                      ],
                      staticClass: "btn btn-info",
                      on: { click: _vm.copyReferralCode }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t(_vm.isCopiedReferralCode)) +
                          "\n            "
                      )
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "my-3" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-block btn-lg -indigo my-2",
                  attrs: {
                    href:
                      "https://www.facebook.com/sharer/sharer.php?u=" +
                      _vm.referralCode.url_referral_code,
                    target: "_blank"
                  }
                },
                [
                  _c("i", { staticClass: "fab fa-facebook-f mr-3" }),
                  _vm._v(" Share on Facebook\n        ")
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "my-3" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-block btn-lg -blue my-2",
                  attrs: {
                    href:
                      "https://twitter.com/intent/tweet?url=" +
                      _vm.referralCode.url_referral_code,
                    target: "_blank"
                  }
                },
                [
                  _c("i", { staticClass: "fab fa-twitter mr-3" }),
                  _vm._v(" Share on Twitter\n        ")
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "my-3" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-block btn-lg -green-line my-2",
                  attrs: {
                    href:
                      "https://social-plugins.line.me/lineit/share?url=" +
                      _vm.referralCode.url_referral_code,
                    target: "_blank"
                  }
                },
                [
                  _c("i", { staticClass: "fab fa-line mr-3" }),
                  _vm._v(" Share on LINE\n        ")
                ]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [_c("hr")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my-4" }, [_c("hr")])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5efb956a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5efb956a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/InviteFriendCampaign.vue
// module id = 1656
// module chunks = 0